var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.736 2c.471.002.934.127 1.341.364l12.464 7.27h-.001a2.677 2.677 0 0 1 .152 4.537l-.148.094-12.467 7.272a2.679 2.679 0 0 1-4.027-2.314V4.678a2.68 2.68 0 0 1 1.344-2.323A2.7 2.7 0 0 1 5.736 2m-.004 1.2A1.48 1.48 0 0 0 4.25 4.677v14.546A1.478 1.478 0 0 0 6.472 20.5l12.467-7.272.16-.109a1.477 1.477 0 0 0-.162-2.447L6.472 3.402h-.001a1.5 1.5 0 0 0-.74-.203"
  })));
};
export default SvgPlay;